module.exports = __webpack_public_path__ + "static/6305-woodrose-59-05360cf444b3508351de0d781cc7e7a7.jpg";